import type { LocaleType } from '@/locales';
import Qs from 'qs';
import type { Platform } from './hub';

/**
 * 解析查询字符串
 * @param { STRING } str 要解析的查询字符串
 * @return { OBJECT } 解析后的结果
 */

export function parseQueryParams(url: string) {
  // 引入 qs 库时会默认挂在到全局 window 的 Qs 属性上
  // console.log(window)
  const urlStr = url.split('?')[1];
  const result = Qs.parse(urlStr);

  return result as Recordable;
}

export function excludeQueryParams(url: string, key: string) {
  if (!url) return '';
  const urlParts = url.split('?');
  const result = Qs.parse(urlParts[1]);
  if (result[key]) {
    delete result[key];
  }
  const restParamsLength = Object.values(result).filter(Boolean).length;

  return urlParts[0] + (restParamsLength < 1 ? '' : `?${Qs.stringify(result)}`);
}
// e'x

export const getPlatform = (): Platform => {
  const { pathname } = window.location;

  if (pathname.includes('admin.html')) {
    const redirectUrl = getQueryItem('redirectUrl', 'hash') || '';
    // console.log('[ redirectUrl ] >', redirectUrl);
    const { platform } = parseQueryParams(redirectUrl);
    return platform || 'admin';
  }
  return 'user';
};

export function getQueryItem(
  key: string,
  sourceType: 'query' | 'hash' = 'query'
) {
  let queryString = window.location.search;
  if (sourceType == 'hash') {
    queryString = window.location.hash.split('?')[1];
  }
  const params = new URLSearchParams(queryString);
  return params.get(key);
}
export function getUrlParam(name: string): LocaleType | null {
  // 解码当前URL
  const currentUrl = decodeURIComponent(window.location.href);

  // 首先检查查询字符串参数
  const urlObj = new URL(currentUrl);
  const queryParam = urlObj.searchParams.get(name);
  if (queryParam) {
    return queryParam as LocaleType;
  }

  // 然后检查哈希部分的参数
  const hash = urlObj.hash;
  if (hash) {
    // 处理形如 #/? 的哈希参数
    const hashParamIndex = hash.indexOf('?');
    if (hashParamIndex !== -1) {
      const hashQueryString = hash.substring(hashParamIndex + 1);
      const hashParams = new URLSearchParams(hashQueryString);
      const hashParam = hashParams.get(name);
      if (hashParam) {
        return hashParam as LocaleType;
      }

      // 检查哈希中嵌套的URL参数
      // Convert entries iterator to array for compatibility
      const entries = Array.from(hashParams.entries());
      for (const [key, value] of entries) {
        if (key !== name && value.includes(`${name}=`)) {
          const nestedUrl = decodeURIComponent(value);
          const nestedParamMatch = new RegExp(`[?&]${name}=([^&]*)`).exec(
            nestedUrl
          );
          if (nestedParamMatch) {
            return nestedParamMatch[1] as LocaleType;
          }
        }
      }
    }
  }

  return null;
}
